// @ts-strict-ignore
import { Injectable, ViewContainerRef } from '@angular/core';
import { SohoModalDialogService, SohoModalDialogRef, SohoMessageService } from 'ids-enterprise-ng';
import { Observable } from 'rxjs';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMDialogButtonKey, LMUniqueIdService } from '@utils/index';
import { LMGenAIPromptDialogComponent } from '@modal/lm-genai-prompt-dialog.component';
import { LMModel } from '@form/model';
import { LMGenAIPromptGeneratedEvent } from '@modal/lm-genai-prompt-dialog';
import { LMFormatUtilService } from '@app/services';

export enum GenAIPromptDialogStatus {
  RESPONSE_CANCEL = 0,
  RESPONSE_OK
}

export interface GenAIPromptDialogResult {
  status: GenAIPromptDialogStatus;
  generated?: string;
  fieldId?: string;
  dataView?: LMDataView;
  model?: LMModel;
}

@Injectable()
export class LMGenAIPromptDialogService {

  constructor(
    private sohoModalDialogService: SohoModalDialogService,
    private sohoMessageService: SohoMessageService,
    private lmLoggerService: LMLoggerService,
    private lmUniqueIdService: LMUniqueIdService,
    private lmFormatUtilService: LMFormatUtilService
  ) {}

  /**
   * Prompt Gen AI Prompt dialog
   * @param viewContainerRef
   *
   * @return Observable<any>
   */
  public promptGenAIDialog(url?: string, fieldId?: string, lmModel?: LMModel, fieldLabel?: string) : Observable<any> {
    const prompt: Observable<GenAIPromptDialogResult> = new Observable<GenAIPromptDialogResult> (observer => {
      let genAIComponent: LMGenAIPromptDialogComponent;
      let dialog: SohoModalDialogRef<any> = undefined;
      const dialogFieldTitle = fieldLabel == undefined || fieldLabel.length == 0 ? Soho.Locale.translate('GenerateAIDialogNoLabelTitle') : this.lmFormatUtilService.formatMessage(Soho.Locale.translate('GenerateAIDialogTitle'), fieldLabel);

      const attributes: SohoAttributesArray = [ {
        name: 'data-automation-id',
        value: 'lm-gen-ai-modal'
      } ];

      const sohoModalOptions: SohoModalOptions = {
        fullsize: false,
        attributes,
        cssClass: this.getCSSClass(),
      };

      const dialogId = 'GenAIPrompt';
      const buttons = [
        {
          id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.APPEND ]),
          text: Soho.Locale.translate(LMDialogButtonKey.APPEND),
          click: (e, modal) => {
            {
              dialog.close(<GenAIPromptDialogResult> {
                status: GenAIPromptDialogStatus.RESPONSE_OK,
                generated: genAIComponent.getGeneratedText(),
                fieldId: genAIComponent.fieldId,
                model: genAIComponent.model,
                dataView: genAIComponent.dataView
              });
            }
          },
          validate: true,
          isDefault: true,
          disabled: true
        }
      ];
      dialog = this.sohoModalDialogService
        .modal(LMGenAIPromptDialogComponent, null, sohoModalOptions)
        .showCloseBtn(true)
        .buttons(buttons)
        .title(dialogFieldTitle)
        .icon('insights-smart-panel')
        .iconClass('info')
        .isAlert(false)
        .open()
        .apply((genAIForm: LMGenAIPromptDialogComponent) => {
          genAIComponent = genAIForm;
          genAIComponent.dataView = lmModel.getData();
          genAIComponent.fieldId = fieldId;
          genAIComponent.model = lmModel;
          genAIComponent.url = url;
          genAIComponent.generatedTextEvent.subscribe((event: LMGenAIPromptGeneratedEvent) => {
            if (event && event.valid) {
              dialog.buttonsetAPI.at(0).disabled = false;
            }
          });
        })
        .afterClose(result => {
          if (!result) {
            result = <GenAIPromptDialogResult>{
              status: GenAIPromptDialogStatus.RESPONSE_CANCEL
            };
          }
          observer.next(result);
          observer.complete();
        });
    });
    return prompt;
  }
  private getCSSClass(): string {
    const cssClass = [ 'lm-action-form-dialog' ];
    cssClass.push('lm-has-composite');
    cssClass.push('lm-full-tabbed-action-form');

    return cssClass.join(' ');
  }
}
